export default {
   registerSuccess: {
      title: "Contragulations",
      text: "You have been successfully registered. Enjoy the game",
   },
   otpResent: {
      title: "OTP Resent",
      text: "Your one time password has been resent to you email. Please enter it to continue",
   },
   canResetNewPassword: {
      title: "OTP verified",
      text: "Your OTP is verified now you can reset your password to a new password. Make sure to remember your new passowrd.",
   },
   passwordReset: {
      title: "Success",
      text: "Your password has been successfully reset to new password. Please login to continue",
   },
   newGameCreated: {
      title: "New game created",
      text: "Wait for other players to join the game.",
   },
};
